import { darkPalette } from "../palette";

export const MuiFormLabel = {
  MuiFormLabel: {
    root: {
      "&.Mui-disabled": {
        color: darkPalette.grey[600],
      },
    },
  },
};
